import React from 'react'
import AddForm from './AddForm'

const AddSupplier = () => {
  return (
    <AddForm page="Add Supplier" />
  )
}

export default AddSupplier
